import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import '../styles/uprn-dataset-popup.css';
const UprnDatasetPopup = ({ feature, onClose }) => {
    const props = feature?.properties || { uprn: 'Unknown' };
    // Parse custom_data if it's a string
    let customData = null;
    if (props.custom_data) {
        if (typeof props.custom_data === 'string') {
            try {
                customData = JSON.parse(props.custom_data);
            }
            catch (e) {
                console.warn('Failed to parse custom_data:', e);
            }
        }
        else if (typeof props.custom_data === 'object') {
            customData = props.custom_data;
        }
    }
    // Build address from components if full_address not available
    const getAddress = () => {
        if (props.full_address) {
            return props.full_address;
        }
        const addressParts = [];
        if (props.building_name)
            addressParts.push(props.building_name);
        if (props.building_number)
            addressParts.push(props.building_number);
        if (props.road_name)
            addressParts.push(props.road_name);
        if (props.city)
            addressParts.push(props.city);
        if (props.county)
            addressParts.push(props.county);
        if (props.postcode)
            addressParts.push(props.postcode);
        return addressParts.length > 0 ? addressParts.join(', ') : null;
    };
    const address = getAddress();
    // Format coordinate display
    const formatCoord = (value) => {
        return value?.toFixed(6) ?? 'N/A';
    };
    return (_jsxs("div", { className: "uprn-dataset-popup", children: [_jsxs("div", { className: "uprn-dataset-popup__header", children: [_jsx("div", { className: "uprn-dataset-popup__header-icon", children: _jsx("i", { className: "fas fa-map-pin" }) }), _jsx("div", { className: "uprn-dataset-popup__header-content", children: _jsxs("div", { className: "uprn-dataset-popup__title-row", children: [_jsx("h3", { className: "uprn-dataset-popup__title", children: "UPRN" }), _jsx("span", { className: "uprn-dataset-popup__uprn-badge", children: props.uprn })] }) })] }), address && (_jsxs("div", { className: "uprn-dataset-popup__section", children: [_jsxs("div", { className: "uprn-dataset-popup__section-label", children: [_jsx("i", { className: "fas fa-home" }), _jsx("span", { children: "Address" })] }), _jsx("div", { className: "uprn-dataset-popup__address", children: address })] })), customData && Object.keys(customData).length > 0 && (_jsxs("div", { className: "uprn-dataset-popup__section", children: [_jsxs("div", { className: "uprn-dataset-popup__section-label", children: [_jsx("i", { className: "fas fa-database" }), _jsx("span", { children: "Dataset Fields" })] }), _jsx("dl", { className: "uprn-dataset-popup__fields", children: Object.entries(customData).map(([key, value]) => {
                            if (value === null || value === undefined || value === '') {
                                return null;
                            }
                            return (_jsxs(React.Fragment, { children: [_jsx("dt", { children: key }), _jsx("dd", { children: String(value) })] }, key));
                        }) })] })), _jsxs("div", { className: "uprn-dataset-popup__footer", children: [_jsxs("div", { className: "uprn-dataset-popup__coord", children: [_jsx("span", { className: "uprn-dataset-popup__coord-label", children: "Lat" }), _jsx("span", { className: "uprn-dataset-popup__coord-value", children: formatCoord(props.latitude) })] }), _jsx("div", { className: "uprn-dataset-popup__coord-divider" }), _jsxs("div", { className: "uprn-dataset-popup__coord", children: [_jsx("span", { className: "uprn-dataset-popup__coord-label", children: "Lng" }), _jsx("span", { className: "uprn-dataset-popup__coord-value", children: formatCoord(props.longitude) })] })] })] }));
};
export default UprnDatasetPopup;
